import { render, staticRenderFns } from "./medium.vue?vue&type=template&id=4ddca0ba&scoped=true"
import script from "./medium.vue?vue&type=script&lang=js"
export * from "./medium.vue?vue&type=script&lang=js"
import style0 from "./medium.vue?vue&type=style&index=0&id=4ddca0ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddca0ba",
  null
  
)

export default component.exports